// extracted by mini-css-extract-plugin
export default {"label":"Label_label__+Vqm8","required":"Label_required__JzOQ-","labelSmall":"Label_labelSmall__bQV3O","labelLarge":"Label_labelLarge__-ux3N"};